

export const programData =[
    {
        name : 'Program Medan',
        destination : 'Medan',
        accommodation : 'Hotel Deli River',
        activity : 'Tjong Afie',
        price : 'Rp. 400000'
    }
]

